import React from 'react';

interface AudioSpeechIconProps {
  style?: React.CSSProperties;
}

const AudioSpeechIcon: React.FC<AudioSpeechIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Audio Speech</title>
      <path d="M25.98 22.5v-15L12.99 0 0 7.5v15L12.99 30l12.99-7.5z" fill="#6A11EA" />
      <path d="M0 22.5L12.99 30l12.99-7.5v-15l-6.495-3.75L0 15v7.5z" fill="#943CFF" />
      <path d="M12.99 30l12.99-7.5v-15L0 22.5 12.99 30z" fill="#DD45D3" />
      <path
        d="M12.99 7.5l-6.495 3.75v7.5l3.249 1.875v3.75L12.99 22.5l6.495-3.75v-7.5L12.99 7.5z"
        fill="#fff"
      />
      <path d="M6.495 26.25L12.99 30l12.99-7.5V15L6.495 26.25z" fill="#FD9D52" />
    </svg>
  );
};

export default AudioSpeechIcon;
